export default __webpack_public_path__ + "static/media/SV1Thumbnail2.7b9d37a0.png";